import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page64() {
  useEffect(() => {
    document.title = "Маяк — Страница 63"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page62" />
        <ForwardLink href="/page64" />
      </div>

      <p style={{ textAlign: "right" }}>63.</p>
      <p>ВНУТРИ. ЛЕСТНИЦА БАШНИ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>МОЛОДОЙ крадется вверх по лестнице.</p>
      <br/>
      <p>ВНУТРИ. МАШИННОЕ ОТДЕЛЕНИЕ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>
        МОЛОДОЙ пытается взломать ЗАМОК ФОНАРНОГО ОТДЕЛЕНИЯ<br/>
        КУХОННЫМ НОЖОМ.
      </p>
      <p>ОН крутит и поворачивает НОЖ в замке...</p>
      <p>Крутит...</p>
      <p>Трясет...</p>
      <p>ВНЕЗАПНО лезвие ножа ломается надвое...</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (под нос)<br/>
        Сукин сын.
      </p>
      <p>
        Он смотрит на НОЖ. Теперь он очень тонкий. Как спица.<br/>
        <i>Идея!</i>
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>
        МОЛОДОЙ на цыпочках подходит к СТОЛУ старика с ТОНКИМ СЛОМАННЫМ ОБЕДЕННЫМ<br/>
        НОЖОМ...
      </p>
      <p>Он слышит храп СТАРИКА (ЗА КАДРОМ) наверху.</p>
      <p>Сует нож в ЗАМОК...</p>
      <p>Трясет его... столешница тоже трясется...</p>
      <p>Стол открыт!</p>
      <p>Тихо открывает его...</p>
      <p>ЖУРНАЛ исчез.</p>
      <p><i>Сукин сын.</i></p>
      <p>СТАРИК продолжает храпеть (ЗА КАДРОМ).</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ДЕНЬ</p>
      <p>
        МОЛОДОЙ смотрит, как СТАРИК спит. ЖУРНАЛ и очки поднимаются<br/>
        и опускаются на животе. Его громкий ХРАП следует за ним. МЕДНЫЕ КЛЮЧИ<br/>
        висят на цепочке, часы спрятаны под подушкой.
      </p>
      <p style={{ textAlign: "right" }}>63.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page62" />
        <ForwardLink href="/page64" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710631763/the-lighthouse-script/sli0xjqvq7ufm48jdtaj.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page64;
